import React from 'react';
import {
    Grid
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { useHistory } from 'react-router-dom';
import Breadcrumbs from '@material-ui/core/Breadcrumbs';
import Typography from '@material-ui/core/Typography';
import Link from '@material-ui/core/Link';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';

import {DEFAULT_BREADCRUMBS} from '../../constants/applicationConstants';

const useStyles = makeStyles((theme) => ({
    root: {
        padding: '5px 20px',
        background: '#D9D9D9',
        border: '0px solid #9A9A9A',
        '& > * + *': {
            marginTop: theme.spacing(2),
        },
        '& a': {
            cursor:'pointer'
        },
    },
}));
  

const DisplayBreadcrumbs = ({items}) => {

    const classes = useStyles();
    const history = useHistory();

    function handleClick(event, item) {
        event.preventDefault();

        if (item.isExternalUrl && item.isExternalUrl===true) {
            window.location.href = item.link;
            return;
        }
        else {
            history.push(item.link);
        }
    }      

    return (
        <Grid container>
            <Grid item xs={12}>
                <div className={classes.root}>
                    <Breadcrumbs separator={<NavigateNextIcon fontSize="small" />} aria-label="breadcrumb">
                        {
                            DEFAULT_BREADCRUMBS.map( item => {
                                return (
                                    <Link key={`nav-${item}`} color="inherit" onClick={(e) => handleClick(e, item)}>
                                        {item.title}
                                    </Link>
                                )
                            })
                        }
                        {
                            (items && items.length>0) ? 
                            items.map((item, index) => {
                                return (index==items.length-1) ? 
                                (<Typography key={`nav-${item}`} color="textPrimary">{item.title}</Typography>) : ( <Link key={`nav-${item}`} color="inherit" onClick={(e) => handleClick(e, item)}>
                                    {item.title}
                                </Link>);
                            }) : ''
                        }
                    </Breadcrumbs>
                </div>                
            </Grid>
        </Grid>
    )
}

export default DisplayBreadcrumbs;